import { OptionValue } from '@/interfaces/optionValue';
import { OptionValueResource, optionValueResource } from '@/resources/optionValue.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł wartości opcji
 *
 * @export
 * @class OptionValueModule
 * @extends {EntityModule<OptionValue, OptionValueResource>}
 */
export class OptionValueModule extends EntityModule<OptionValue, OptionValueResource> {
  constructor() {
    super(optionValueResource);

    this.state = {
      ...this.state,
      options: {}
    } as any;

    this.mutations = {
      ...this.mutations,

      /**
       * Zapisuje wartość opcji o danym kodzie
       */
      saveByCode: (localState: any, optionValue: OptionValue): void => {
        if (optionValue.option) {
          localState.options = { ...localState.options, [optionValue.option.code]: optionValue };
        }
      }
    };

    this.actions = {
      ...this.actions,
      getByCode: (context: any, { code, entityType, entityId }): Promise<OptionValue> => {
        return this.resource.getByCode(code, entityType, entityId).then(result => {
          context.commit('saveByCode', result);
          return result;
        });
      }
    };
  }
}

export default new OptionValueModule();
